import script from "./nomination-card-image.vue?vue&type=script&setup=true&lang=js"
export * from "./nomination-card-image.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__